export default {"src":"/_next/static/media/ditto-logo.8fe7cae6.svg","height":90,"width":93};